import _sfc_main from './row-container.vue.js';
/* empty css                   */
import _export_sfc from '../../_virtual/_plugin-vue_export-helper.js';

const RowContainer = /* @__PURE__ */ _export_sfc(_sfc_main, [["__scopeId", "data-v-ffa34b2d"]]);

export { RowContainer as default };
//# sourceMappingURL=row-container.js.map
